import wrapError from "@/components/helpers/wrapError"
import {
  createExperience,
  deleteExperience,
  updateExperience,
} from "@/components/profile/helpers/AJAXHelpers"

export const apiClaimZoomProfile = (success, error) => {
  $.ajax({
    type: "POST",
    url: "/api/zoomAccount",
    dataType: "json",
    processData: false,
    contentType: "application/json; charset=utf-8",
    success,
    error: wrapError(error, "apiClaimZoomProfile"),
  })
}

export const apiDeleteClaimedZoomProfile = (success, error) => {
  $.ajax({
    type: "DELETE",
    url: "/api/zoomAccount",
    success,
    error: wrapError(error, "apiDeleteClaimedZoomProfile"),
  })
}

export const updateCurrentUser = (body, success, error) => {
  $.ajax({
    type: "POST",
    url: "/api/contactInfo",
    dataType: "json",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify(body),
    success,
    error: wrapError(error, "updateCurrentUser"),
  })
}

export const addUserAffinity = (affinity, success, error) => {
  $.ajax({
    type: "POST",
    url: "/api/affinity",
    dataType: "json",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify({
      affinityName: affinity.affinityName,
      affinityCategory: affinity.affinityCategory,
    }),
    success,
    error: wrapError(error, "addUserAffinity"),
  })
}

export const deleteUserAffinity = (affinityId, success, error) => {
  $.ajax({
    type: "DELETE",
    url: `/api/affinity/${affinityId}`,
    success,
    error: wrapError(error, "deleteUserAffinity"),
  })
}

export const addUserRelationship = (relationship, success, error) => {
  $.ajax({
    type: "POST",
    url: "/api/relationship",
    dataType: "json",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify(relationship),
    success,
    error: wrapError(error, "addUserRelationship"),
  })
}

export const deleteUserRelationship = (relationshipId, success, error) => {
  $.ajax({
    type: "DELETE",
    url: `/api/relationship/${relationshipId}`,
    dataType: "JSON",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: "{}",
    success,
    error: wrapError(error, "deleteUserRelationship"),
  })
}

export const createPosition = createExperience("position")
export const createDegree = createExperience("degree")
export const deletePosition = deleteExperience("position")
export const deleteDegree = deleteExperience("degree")
export const updatePosition = updateExperience("position")
export const updateDegree = updateExperience("degree")

export const saveAvatar = (img, success, error) => {
  $.ajax({
    url: "/api/avatar",
    type: "POST",
    dataType: "JSON",
    data: { img },
    success,
    error: wrapError(error, "saveAvatar"),
  })
}

export const apideleteAllUserExperiences = (experienceType, success, error) => {
  $.ajax({
    url: "/api/deleteAllExperiencesManager",
    type: "POST",
    dataType: "JSON",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify({ experienceType }),
    success,
    error: wrapError(error, "apideleteAllUserExperiences"),
  })
}

export const apiFetchAffinitySuggestions = (query, success, error) => {
  $.ajax({
    type: "GET",
    url: `/api/affinityAutocompleteManager?query=${encodeURIComponent(query)}`,
    success,
    error: wrapError(error, "apiFetchAffinitySuggestions"),
  })
}

export const apiFetchIndustrySuggestions = (query, success, error) => {
  $.ajax({
    type: "GET",
    url: `/api/industryAutocompleteManager?query=${encodeURIComponent(query)}`,
    success,
    error: wrapError(error, "apiFetchIndustrySuggestions"),
  })
}

export const apiInviteToZoom = (params, success, error) => {
  $.ajax({
    type: "POST",
    url: "/api/scheduleZoomManager",
    success,
    dataType: "json",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify(params),
    error: wrapError(error, "apiInviteToZoom"),
  })
}
